import ErrorLabel from "components/ErrorLabel";
import PageLoading from "components/PageLoading";
import React, { useEffect, useRef, useState } from "react";
import * as Plotly from "plotly.js";
import { useInView } from "react-intersection-observer";
import { imageConfig, plotConfig } from "./ReportConfig";

const PlotlyReport = ({ report, chartData, layout, isLoading, error, width }) => {
  const plotRef = useRef(null);
  const [imageSrc, setImageSrc] = useState(report.imageSrc);
  const [isRendering, setRendering] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  const handleVisibilityChange = isVisible => setIsVisible(isVisible);

  const [ref, inView] = useInView({
    triggerOnce: false,
    onChange: handleVisibilityChange
  });

  const generatePlotlyImage = async () => {
    if (chartData && !isRendering && isVisible && !imageSrc) {
      setRendering(true);
      report.imageSrc = null;
      const plot = await Plotly.react(`plotly_div${report.Id}`, chartData || report.chartData, { ...layout, height: 240, width: width }, plotConfig);
      const url = await Plotly.toImage(plot, { ...imageConfig, width: width });
      setImageSrc(url);
    }
  };

  useEffect(() => {
    generatePlotlyImage();
  }, [isVisible]);

  useEffect(() => {
    if (chartData) {
      report.chartData = chartData;
    }
    setImageSrc(null);
  }, [chartData]);

  useEffect(() => {
    if (!imageSrc) {
      generatePlotlyImage();
    } else {
      report.imageSrc = imageSrc;
      setRendering(false);
    }
  }, [imageSrc]);

  return (
    <>
      {isLoading ? (
        <PageLoading isLoading={isLoading} customHeight="200px"></PageLoading>
      ) : (
        <>
          {error ? (
            <ErrorLabel message={error} className="position-relative"></ErrorLabel>
          ) : (
            <div ref={ref}>
              {(chartData || report.chartData) && (
                <div className="flex-center-center" style={{ maxWidth: width }}>
                  {!imageSrc && report.imageSrc && <img src={report.imageSrc} style={{ width: width, height: 240 }} />}
                  {imageSrc && !isRendering ? (
                    <img src={imageSrc} style={{ width: width, height: 240 }} />
                  ) : (
                    <div id={`plotly_div${report.Id}`} ref={plotRef}></div>
                  )}
                </div>
              )}
            </div>
          )}
        </>
      )}
    </>
  );
};

export default PlotlyReport;
